module.exports = __webpack_public_path__ + "img/desc2.4b5f9091.png";